import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  PaginatedHolidaysDocument,
  AddHolidaysMutation,
  AddHolidaysMutationVariables,
  AddHolidaysDocument,
} from "@/graphql/__generated__/graphql";
import { resetPaginationField } from "@/store/paginationStore";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

/**
 * Custom hook for adding a holidays and handling the necessary cache updates.
 * @returns {Object} - Contains the addHolidaysMutation function, loading state, and error state.
 */
export default function useAddHolidaysMutationHook(): { addHolidaysMutation: any, loading: any, error: any } {

  const { t } = useTranslation(["toasts"]);

  const [addHolidaysMutation, { loading, error }] = useMutation<AddHolidaysMutation, AddHolidaysMutationVariables>(
    AddHolidaysDocument, {
      onCompleted: (data) => {
        if (data.addHolidays === 0) {
          toast(CustomToastComponent, {
            toastId: "holidays-already-exists",
            data: {
              title: t("toasts.holidaysalreadyexists"),
              type: "info"
            }
          });
        } else {
        // Reset pagination to first page to avoid cache inconsistencies
          resetPaginationField("paginatedHolidays");

          toast(CustomToastComponent, {
            toastId: "holidays-added-success",
            data: {
              title: t("toasts.holidaysaddedsuccessfully"),
              type: "success"
            }
          });
        }
      },
      refetchQueries: [
        {
          query: PaginatedHolidaysDocument,
          variables: {
            first: 10,
            after: null,
            currentPage: 0,
            filters: {
              date: null,
              provinces: null
            },
            sort: null
          }
        }
      ]
    });

  return {
    addHolidaysMutation,
    loading,
    error
  };
}
